import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import { JOURNAL_ENTRY_PAGES} from './constants';
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import {userInfoSelector} from "../../../redux/selectors/auth";
import {
    deleteJournalEntry, deleteJournalEntryFromLedger,
    journalEntries,
    listAllLedgers,
    saveJournalEntry,
} from '../../../redux/actions/accounting';
import { journalEntrySelector, ledgerSelector } from '../../../redux/selectors/accounting';
import { tableSettingSelector } from '../../../redux/selectors/account';
import { getTableSetting, saveTableSetting } from '../../../redux/actions/account';
import JournalEntryTable from './JournalEntryTable';
import EditJournalEntry from './EditJournalEntry';

class JournalEntry extends React.Component {
    constructor(props) {
        super(props);

        const currentYear = new Date().getFullYear();
        const startYear = 2023;
        const years = Array.from(
          { length: currentYear - startYear + 1 },
          (_, i) => (startYear + i).toString()
        );

        this.state = {
            currentPage: JOURNAL_ENTRY_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            years: years,
            selectedYear: "2024",
            currency: ['CAD', 'USD'],
            selectedCurrency: 'CAD',
            isEdit : false,
            journalEntryFilterSetting: null,
            journalEntryEditing: {}
        }
    }


    componentDidMount() {
        this.props.getTableSetting(this.props.user.userId)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText){
            this.openFeedbackBar()
        }

        if (prevProps.tableSetting !== this.props.tableSetting) {
            this.setState({ journalEntryFilterSetting: this.props.tableSetting?.journalEntryFilterSetting },()=>{
                this.setState({
                    selectedCurrency: this.state.journalEntryFilterSetting.currency,
                    selectedYear: this.state.journalEntryFilterSetting.year,

                },()=>{
                    this.listJournalEntry()
                })
            })
        }

    }

    listJournalEntry = () =>{
        this.props.listAllLedgers({currency: this.state.selectedCurrency, year: this.state.selectedYear})
        this.props.journalEntries({currency: this.state.selectedCurrency, year: this.state.selectedYear})
    }

    onFiltersInputChange = (name,event) => {
        let filtersMap = this.props.tableSetting?.journalEntryFilterSetting
        filtersMap[name] = event.target.value;
        this.saveUpdatedFilters(filtersMap)
    }


    saveUpdatedFilters = (filters) => {
        this.props.saveTableSetting({
            userId: this.props.user.userId,
            tableSetting: null,
            changeFilters: false,
            changeJournalEntryFilters: true,
            journalEntryFilters: filters
        })
    }


    setIsEdit = (bool) =>{
        this.setState({ isEdit: bool })
    }


    setCurrentPage = (newPage,data) => {
        this.setState({
            currentPage: newPage,
            journalEntryEditing: data,
        })
    }


    handleCurrencyChange = (event) => {
            this.setState({ selectedCurrency: event.target.value },()=>{
                this.onFiltersInputChange("currency",event)
                this.setIsEdit(false)
            })
    }

    handleYearChange = (event) => {
            this.setState({ selectedYear: event.target.value },()=>{
                this.onFiltersInputChange("year",event)
            })
    }

    displayCreateJournal = () => {
        return (
          <EditJournalEntry
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                allLedgers={this.props.ledgers}
                entries={this.props.entries || []}
                selectedYear={this.state.selectedYear}
                selectedCurrency={this.state.selectedCurrency}
                saveJournalEntry={this.props.saveJournalEntry}
                journalEntryEditing={this.state.journalEntryEditing}
                listJournalEntries={this.props.journalEntries}
                currency={this.state.currency}
                years={this.state.years}
                handleYearChange={this.handleYearChange}
                handleCurrencyChange={this.handleCurrencyChange}
                deleteJournalEntryFromLedger={this.props.deleteJournalEntryFromLedger}
            />
        )
    }

    displayTable = () => {
            return (
              <JournalEntryTable
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                selectedYear={this.state.selectedYear}
                handleYearChange={this.handleYearChange}
                currency={this.state.currency}
                selectedCurrency={this.state.selectedCurrency}
                handleCurrencyChange={this.handleCurrencyChange}
                years={this.state.years}
                allJournalEntries={this.props.allJournalEntries}
                deleteJournalEntry={this.props.deleteJournalEntry}
              />
            )
    }


    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case JOURNAL_ENTRY_PAGES.TABLE:
                return this.displayTable()
            case JOURNAL_ENTRY_PAGES.EDIT:
                return this.displayCreateJournal()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = () => {
        this.setState({feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false }, () => {
            this.props.clearStatus()
        })
    }


    render() {
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.props.status?.success ? 'success' : 'error'}
                    message={this.props.status?.statusText}
                />
                {this.displayCurrentPage()}
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => ({
    status: statusSelector(state),
    user: userInfoSelector(state),
    tableSetting: tableSettingSelector(state),
    ledgers: ledgerSelector(state),
    allJournalEntries: journalEntrySelector(state)
})


const actionCreators = {
    clearStatus,
    saveTableSetting,
    getTableSetting,
    listAllLedgers,
    journalEntries,
    deleteJournalEntry,
    saveJournalEntry,
    deleteJournalEntryFromLedger

}

export default withShipment({
    actionCreators,
    mapStateToProps
}, JournalEntry);